// Shared by API and UI. A warning must not turn an unreliable transcription
// into an editable/importable menu. Legacy previews are checked as well.
const QUALITY_MESSAGE = 'Non riusciamo a leggere con sicurezza piatti, ingredienti o prezzi. Carica il PDF originale o foto più nitide, una sezione alla volta. Nessun piatto è stato aggiunto.';
const IMAGE_SIZE_MESSAGE = 'Foto troppo piccola per leggere il menù. Carica il PDF originale o una foto di almeno 400 × 300 pixel, anche in verticale. Nessuna importazione utilizzata.';
const unreadable = /illeggibil|non leggibil|non (?:ben )?chiar|incert|ambigu|sfocat|tagliat|incomplet|confus|unreadable|unclear/i;
function qualityBlocked(preview) {
  if (!preview || !Array.isArray(preview.items) || !Array.isArray(preview.warnings)) return true;
  if (preview.readability != null && preview.readability !== 'clear') return true;
  if (preview.warnings.some((note) => unreadable.test(String(note)))) return true;
  return preview.items.some((item) => {
    if (!item || (item.uncertainFields && (!Array.isArray(item.uncertainFields) || item.uncertainFields.length))) return true;
    if (!Array.isArray(item.uncertain)) return true;
    // A clearly printed weight/range price is not a transcription failure.
    // All other per-item uncertainty blocks the extraction, including old jobs.
    return item.uncertain.some((note) => unreadable.test(String(note)) || !/\b(?:kg|etto|etti|intervallo)\b/i.test(String(note)));
  });
}
module.exports = { qualityBlocked, QUALITY_MESSAGE, IMAGE_SIZE_MESSAGE };
